export const stepOneData = [
  {
    stepOneHeading: "1. Check Your Credit",
    creditScoreInfo:
      "Before applying, review your credit score to gauge your chances of approval and find potential loan terms. Higher scores improve your approval chances and may help you secure lower rates. Here’s how scores typically rank:",
    categoryHeading: "Credit scores typically fall into these categories.",
    creditScoreCategories: [
      {
        excellentCredit: "750 and above: Excellent credit.",
        goodCredit: "700-749: Good credit.",
        averageCredit: "650-699: Fair credit.",
        badCredit: "Below 650: Poor credit.",
      },
    ],
    creditScoreList: [
      {
        head: "750 and above: ",
        info: "Excellent credit.",
      },
      {
        head: "700-749: ",
        info: "Good credit.",
      },
      {
        head: "650-699: ",
        info: "Fair credit.",
      },
      {
        head: "Below 650: ",
        info: "Poor credit.",
      },
    ],
    paraTwo:
      "Tip: Check your score for free on Minemi, and review your credit report from credit bureaus like CIBIL or Experian. Correct any errors that might affect your score, and prioritize timely payments and low credit utilization.",
  },
];

export const stepTwoData = [
  {
    stepTwoHeading: "2. Calculate Your Loan Payments",
    decideBeforeTakeLoan:
      "First, decide how much you need to borrow, factoring in potential processing fees. Many lenders charge a processing fee of 1%-3%, which they deduct from the loan disbursal amount. Use Minemi’s loan calculator to estimate your monthly payments based on the loan amount, interest rate, and loan tenure.",
    thenEstimate: "Sample APR Estimates Based on Credit Score",

    loanPaymentsTable: {
      heading: [
        {
          head: "Borrower Credit Rating",
        },
        {
          head: "Score Range",
        },
        {
          head: "Estimated APR",
        },
      ],
      rows: [
        {
          creditRating: "Excellent",
          score: "750-900",
          estimated: "10.5%",
        },
        {
          creditRating: "Good",
          score: "700-749",
          estimated: "12.5%",
        },
        {
          creditRating: "Fair",
          score: "650-699",
          estimated: "15.5%",
        },
        {
          creditRating: "Poor",
          score: "550-649",
          estimated: "18.5%",
        },
        {
          creditRating: "Very Poor",
          score: "300-549",
          estimated: "22.0%",
        },
      ],
    },

    amortizationHeading: [
      {
        head: "Payment Date",
      },
      {
        head: "Principal Component",
      },
      {
        head: "Interest Component",
      },
      {
        head: "Total Monthly Payment ",
      },
      {
        head: "Remaining Balance",
      },
    ],

    disclaimer:
      " The APRs provided are estimates based on industry averages and are not specific to any lender. Actual rates may vary based on lender policies and individual credit profiles.",
    loanTenureTip:
      "Consider how long you’ll need to pay off the loan. Longer loan tenures mean smaller monthly payments, but you’ll pay more in interest over time. Choosing a shorter tenure can save you interest if it comfortably fits within your budget.",
    useCalculator:
      "Once you know your loan amount, rate and term, use our personal loan calculator to determine your estimated monthly payments. The best personal loans have payments that fit comfortably into your budget.",
  },
];

export const stepThreeData = [
  {
    stepThreeHeading: "3. Research and Compare Lenders",
    paraOne:
      "You can get a personal loan from banks, NBFCs, and digital lenders, each offering unique benefits for various customer profiles. When comparing lenders, look at:",
    creditScoreRequirements:
      "Banks may require high credit scores, while NBFCs and digital lenders may accept lower scores.",

    loanAmountsAndTerms:
      "Loan amounts typically range from ₹50,000 to ₹50 lakh with tenures from 12 to 60 months. Select lenders with loan terms suited to your needs.",
    fundingSpeed:
      "Digital lenders often disburse funds faster, with some offering same-day funding upon approval.",
    securedLoans:
      "Some lenders allow co-signers or collateral, which may improve approval chances and rates.",
  },
];

export const stepFourData = [
  {
    stepFourHeading: "4. Get Principal Approval for Loan Offers",
    paraOne:
      "In India, many banks offer pre-approved or principal-approved loan options based on your banking history. This step gives you a head start by helping you understand the terms you might receive, without impacting your credit score.",

    approvalList: [
      {
        head: "Pre-Approval with Your Bank: ",
        info: " If you have a savings account or credit card with a bank, check to see if they offer pre-approved loan options based on your existing relationship.",
      },
      {
        head: "Principal Approval on Bank Websites: ",
        info: "Some banks allow you to get principal approval by applying through their website, giving you a preliminary assessment of loan eligibility and terms.",
      },
    ],
  },
];

export const stepFiveData = [
  {
    stepFiveHeading: "5. Select a Lender and Complete Your Application",
    paraOne:
      "After narrowing down your options, choose the lender that offers the best terms and proceed with the application. Lenders generally require:",

    requireList: [
      {
        head: "Identification:",
        info: "Aadhaar, PAN, or Passport.",
      },
      {
        head: "Proof of Address:",
        info: "Utility bills, lease agreements, or Passport.",
      },
      {
        head: "Proof of Income:",
        info: "Salary slips, bank statements, or income tax returns.",
      },
    ],

    paraTwo:
      "The lender will conduct a hard credit check, which may temporarily impact your credit score. Some lenders provide an immediate decision, while others may take a few days.",
    paraThree:
      "Some lenders provide an immediate approval decision while others may take a couple days",
  },
];

export const stepSixData = [
  {
    stepSixHeading: "6. Review the Fine Print",
    paraOne:
      "Before signing the agreement, carefully examine the terms. Be mindful of:",
    fees: "Prepayment penalties — fees for paying off a loan early — are rare, but lenders may charge other fees, including origination and late payment fees.",
    aprSuprices:
      "The total cost of your loan, including interest and any origination fees, should be clearly disclosed and figured into the APR.",
    automaticWithdrawals:
      "If a lender automatically withdraws loan payments from your checking account, consider setting up a low-balance alert with your bank to avoid overdraft fees.",
  },
];

export const stepSevenData = [
  {
    stepSevenHeading: "7. Sign the Loan Agreement and Receive Funds",
    paraOne:
      "After signing, the funds are typically disbursed within a few days. Many digital lenders offer same-day or next-day disbursal to your account, enabling you to use the funds promptly.",
    paraTwo:
      "Tip: Create a repayment plan to stay on top of EMIs, as your first payment is usually due 30 days after disbursal.",

    successTipList: [
      {
        head: "If Denied, Improve for Next Time: ",
        info: "If Denied, Improve for Next Time: If your application is denied, request feedback from the lender. This can guide you in strengthening your credit score or lowering your debt-to-income ratio to improve future approval chances.",
      },
      {
        head: "Automate Payments: ",
        info: "Setting up auto-pay can help ensure on-time payments, avoiding late fees and supporting a positive credit history.",
      },
    ],
  },
];
